import { FC, useEffect, useState, useRef } from 'react';
import { Typography, Grid, IconButton, Tooltip, Checkbox } from '@mui/material';
import { useAppDispatch } from '../../../hooks';
import { getFormattedEndDateString, getFormattedStartDateString } from '../../../utils';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { fetchSitesPdf } from './Services';
import { showAlertAction } from '../../../store/alerts';
import { getAllSitesLedgerDataAction } from './actions';
import { DateRangeSelector } from '../../../components';

export const circleButtonSize = '32px'
export const circleIconSize = '18px'

export interface AllSitesLedgerHeaderProps {
  onChecked: (checked: boolean) => void
}

const AllSitesLedgerHeader: FC<AllSitesLedgerHeaderProps> = ({onChecked}) => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [checked, setChecked] = useState(true);
  const dispatchAction = useAppDispatch();
  
  // Store current dates for PDF export
  const currentDatesRef = useRef<{ start: Date; end: Date } | null>(null);

  const fetchPDF = () => {
    if (!currentDatesRef.current) return;
    
    const startDate = getFormattedStartDateString(currentDatesRef.current.start, true);
    const endDate = getFormattedEndDateString(currentDatesRef.current.end, true);
    setIsEnabled(false)
    fetchSitesPdf(startDate, endDate).then(
      (response) => {
        setIsEnabled(true)
        if (response.success) {
          window.open(response.data, '_blank')
        } else {
          dispatchAction(
            showAlertAction({
              message: response.message,
              severity: 'error',
            })
          )
        }
      }
    )
  }

  const handleDateRangeChange = (startDate: Date, endDate: Date, _preset: string) => {
    // Store dates for PDF export
    currentDatesRef.current = { start: startDate, end: endDate };
    
    // Fetch data
    const start = getFormattedStartDateString(startDate, true);
    const end = getFormattedEndDateString(endDate, true);
    dispatchAction(getAllSitesLedgerDataAction(start, end));
  };

  const onCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChecked(event.target.checked)
    setChecked(event.target.checked)
  }

  return (
    <>
      <Grid container alignItems="stretch">
        <Grid item md={4}>
          <Typography variant="h3" component="h3">
           Month-Wise Billing
          </Typography>
        </Grid>
        <Grid item md={1}>
        </Grid>
        <Grid
          md={7}
          item
          sx={{ width: 250, textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'center' }}
        >
          <Checkbox checked={checked} onChange={onCheckBoxChange}/> Sum

          <Tooltip title="Export PDF">
            <IconButton
              disabled={!isEnabled}
              onClick={() => {
                fetchPDF();
              }}
              sx={{
                ml: 3,
                mr: 4,
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                color: 'white',
                width: {circleButtonSize},
                height: {circleButtonSize},
                borderRadius: '50%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <PictureAsPdfIcon sx={{width:circleIconSize, height:circleIconSize}}/>
            </IconButton>
          </Tooltip>
          <div style={{marginBottom: -20}}>
            <DateRangeSelector
              onChange={handleDateRangeChange}
              defaultPreset="last6Months"
              showViewButton={false}
              triggerOnMount={true}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default AllSitesLedgerHeader;
